module.exports = __webpack_public_path__ + "img/F8.ad95c88b.png";